/**
 * action creator that fires the ReduxForm CHANGE action
 */
export default (form, field, value, touch, persistentSubmitErrors) => ({
  type: `@@redux-form/CHANGE`,
  meta: { form, field, touch, persistentSubmitErrors },
  payload: value,
})
